<div class="mobile-warning-banner" *ngIf="isMobileOrTablet">
  <mat-icon class="warning-icon">warning</mat-icon>
  <span class="warning-text">
    <strong>For the best experience:</strong> We recommend using this portal on
    a desktop/laptop device, as it was specifically built for that use.
  </span>
</div>

<app-toolbar></app-toolbar>

<div class="dashboard-container">
  <!-- Dashboard Content -->
  <div class="dashboard-content">
    <!-- Dashboard Header -->
    <div class="dashboard-header">
      <h1 class="dashboard-title">Dashboard</h1>
      <div class="action-buttons">
        <app-action-dropdown
          label="More"
          [options]="moreOptions"
          (optionSelected)="onMoreOptionSelected($event)"
        ></app-action-dropdown>
        <button class="start-new-btn" (click)="startNew()">Start New</button>
      </div>
    </div>

    <!-- Reassign success alert -->
    <div class="reassign-alert" *ngIf="reassignAlert">
      <mat-icon class="reassign-alert-icon">check_circle</mat-icon>
      <span>{{ reassignAlert }}</span>
      <button class="reassign-alert-close" (click)="reassignAlert = null">×</button>
    </div>

    <!-- Tab Navigation -->
    <div class="custom-tabs">
      <div class="tab-headers">
        <button
          class="tab-header"
          [class.active]="activeTab === 'all'"
          (click)="switchTab('all')"
        >
          All ROPA
        </button>
        <button
          class="tab-header"
          [class.active]="activeTab === 'my'"
          (click)="switchTab('my')"
        >
          My ROPA
        </button>
      </div>

      <div class="tab-content-container">
        <!-- All R.O.P.A Tab Content -->
        <div class="tab-content" [class.active]="activeTab === 'all'">
          <!-- Loading state -->
          <div
            class="loading-container"
            *ngIf="isLoading && activeTab === 'all'"
          >
            <div class="loading-spinner"></div>
            <p>Loading ROPAs...</p>
          </div>

          <!-- Error state -->
          <div
            class="error-container"
            *ngIf="error && !isLoading && activeTab === 'all'"
          >
            <div class="error-message">
              <h3>Error</h3>
              <p>{{ error }}</p>
              <button
                type="button"
                class="start-new-btn"
                (click)="loadAllRopas()"
              >
                Retry
              </button>
            </div>
          </div>

          <!-- Empty state when no ROPAs -->
          <div
            class="empty-state"
            *ngIf="
              allROPAs.length === 0 &&
              !isLoading &&
              !error &&
              activeTab === 'all'
            "
          >
            <p class="empty-message">No Pending ROPA's Found..</p>
            <button class="start-new-btn" (click)="startNew()">
              Start New
            </button>
          </div>

          <!-- ROPA List when ROPAs exist -->
          <div
            class="ropa-list"
            *ngIf="
              allROPAs.length > 0 && !isLoading && !error && activeTab === 'all'
            "
          >
            <div class="list-header">
              <span class="list-title"
                >List <span>({{ allROPAs.length }} Results)</span></span
              >
              <div class="list-actions">
                <button class="action-btn" (click)="toggleSearch()">
                  <mat-icon>search</mat-icon>
                  Search
                </button>
                <div class="sort-dropdown-container">
                  <button class="action-btn filter-btn" (click)="toggleSort()">
                    <mat-icon>filter_list</mat-icon>
                    Sort
                    <mat-icon class="dropdown-arrow">{{
                      showSortDropdown ? "expand_less" : "expand_more"
                    }}</mat-icon>
                  </button>
                  <div class="sort-dropdown" *ngIf="showSortDropdown">
                    <button class="sort-option" (click)="sortBy('set_area')">
                      SET Area
                    </button>
                    <button class="sort-option" (click)="sortBy('country')">
                      Country
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="search-container" *ngIf="showSearchBar">
              <img
                src="assets/icons/search.svg"
                alt="Search"
                class="icon-search"
              />
              <input
                type="text"
                placeholder="Search for..."
                class="search-input"
                [(ngModel)]="searchQuery"
                (input)="onSearchChange()"
              />
              <mat-icon
                *ngIf="searchQuery"
                class="clear-search-icon"
                (click)="clearSearch()"
                >close</mat-icon
              >
            </div>

            <div
              class="search-results"
              *ngIf="showSearchBar && searchQuery !== ''"
            >
              Search Results: {{ filteredAllROPAs.length }} of
              {{ allROPAs.length }} ROPAs
            </div>

            <div class="ropa-item" *ngFor="let ropa of filteredAllROPAs">
              <div class="ropa-header">
                <h3 class="ropa-name">
                  {{ ropa.ropa }}
                  <span class="version">
                    Version
                    <select
                      [(ngModel)]="ropa.version"
                      (change)="onVersionChange(ropa)"
                    >
                      <option *ngFor="let v of ropa.versions" [ngValue]="v">
                        {{ v }}
                      </option>
                    </select>
                  </span>
                </h3>
                <span class="status-badge" [ngClass]="ropa.has_active_draft ? 'in-progress' : 'complete'">
                  <ng-container *ngIf="ropa.has_active_draft; else completeIcon">
                    <span class="material-symbols-outlined" aria-hidden="true" style="font-size:16px;vertical-align:middle;">priority_high</span>
                  </ng-container>
                  <ng-template #completeIcon>
                    <img
                      src="../../../../../assets/icons/submitted.svg"
                      alt="complete"
                    />
                  </ng-template>
                  {{ ropa.has_active_draft ? 'New version in progress' : 'Complete' }}</span
                >
              </div>

              <div class="ropa-details">
                <div class="detail-row">
                  <div class="detail-item">
                    <span class="label">Project title <span class="version-badge">Version {{ ropa.version }}</span></span>
                    <span class="value">{{ ropa.project_title }}</span>
                  </div>
                  <div class="detail-item">
                    <span class="label">SET Area</span>
                    <span class="value">{{ ropa.set_area }}</span>
                  </div>
                  <div class="detail-item">
                    <span class="label">Country</span>
                    <span class="value">{{
                      getFormattedCountries(ropa.countries)
                    }}</span>
                  </div>
                  <div class="detail-item">
                    <span class="label">Published Date</span>
                    <span class="value"
                      >{{
                        ropa.created_date | date : "MM/dd/yyyy HH:mm"
                      }}
                      UTC</span
                    >
                  </div>
                  <div class="detail-item">
                    <span class="label">Submitted by:</span>
                    <span class="value">{{ ropa.submitted_by }}</span>
                  </div>
                  <div class="detail-item" *ngIf="ropa.has_active_draft">
                    <span class="label">Edited by:</span>
                    <span class="value">{{ ropa.edited_by }}</span>
                  </div>
                </div>
              </div>

              <div class="ropa-actions">
                <button
                  class="action-btn download-btn"
                  (click)="downloadRopa(ropa)"
                >
                  Download
                </button>
                <div class="flex">
                  <button
                    class="action-btn create-version-btn"
                    [disabled]="ropa.has_active_draft"
                    [attr.aria-disabled]="ropa.has_active_draft || null"
                    [title]="ropa.has_active_draft ? 'A new version is already in progress' : ''"
                    (click)="createNewVersion(ropa)"
                  >
                    Create new version
                  </button>
                  <button
                    class="action-btn view-btn"
                    (click)="viewRopa(ropa, false)"
                  >
                    View ROPA
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End All R.O.P.A Tab -->

        <!-- Conflict error modal (ROPAT-159) -->
        <app-status-change-modal
          [isOpen]="showConflictModal"
          [state]="'error'"
          [errorMessage]="conflictErrorMessage"
          (close)="onConflictModalClose()"
        >
        </app-status-change-modal>

        <!-- My R.O.P.A Tab Content -->
        <div class="tab-content" [class.active]="activeTab === 'my'">
          <!-- Loading state -->
          <div
            class="loading-container"
            *ngIf="isLoading && activeTab === 'my'"
          >
            <div class="loading-spinner"></div>
            <p>Loading your ROPAs...</p>
          </div>

          <!-- Error state -->
          <div
            class="error-container"
            *ngIf="error && !isLoading && activeTab === 'my'"
          >
            <div class="error-message">
              <h3>Error</h3>
              <p>{{ error }}</p>
              <button
                type="button"
                class="start-new-btn"
                (click)="loadDrafts()"
              >
                Retry
              </button>
            </div>
          </div>

          <!-- Empty state when no ROPAs -->
          <div
            class="empty-state"
            *ngIf="
              myROPAs.length === 0 && !isLoading && !error && activeTab === 'my'
            "
          >
            <p class="empty-message">No Pending ROPA's Found..</p>
            <button class="start-new-btn" (click)="startNew()">
              Start New
            </button>
          </div>

          <!-- ROPA List when ROPAs exist -->
          <div
            class="ropa-list"
            *ngIf="
              myROPAs.length > 0 && !isLoading && !error && activeTab === 'my'
            "
          >
            <div class="list-header">
              <span class="list-title"
                >List <span>({{ myROPAs.length }} Results)</span></span
              >
              <div class="list-actions">
                <button class="action-btn" (click)="toggleSearch()">
                  <mat-icon>search</mat-icon>
                  Search
                </button>
                <div class="sort-dropdown-container">
                  <button class="action-btn filter-btn" (click)="toggleSort()">
                    <mat-icon>filter_list</mat-icon>
                    Sort
                    <mat-icon class="dropdown-arrow">{{
                      showSortDropdown ? "expand_less" : "expand_more"
                    }}</mat-icon>
                  </button>
                  <div class="sort-dropdown" *ngIf="showSortDropdown">
                    <button class="sort-option" (click)="sortBy('set_area')">
                      SET Area
                    </button>
                    <button class="sort-option" (click)="sortBy('country')">
                      Country
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="search-container" *ngIf="showSearchBar">
              <img
                src="assets/icons/search.svg"
                alt="Search"
                class="icon-search"
              />
              <input
                type="text"
                placeholder="Search for..."
                class="search-input"
                [(ngModel)]="searchQuery"
                (input)="onSearchChange()"
              />
              <mat-icon
                *ngIf="searchQuery"
                class="clear-search-icon"
                (click)="clearSearch()"
                >close</mat-icon
              >
            </div>

            <div class="search-results" *ngIf="showSearchBar">
              Search Results: {{ filteredMyROPAs.length }} of
              {{ myROPAs.length }} ROPAs
            </div>

            <div class="ropa-item" *ngFor="let ropa of filteredMyROPAs">
              <div class="ropa-header">
                <h3 class="ropa-name">
                  {{ getDraftRopaName(ropa) }}
                </h3>
                <span class="status-badge complete">
                  <img
                    src="../../../../../assets/icons/draft.svg"
                    alt="complete"
                  />
                  Draft</span
                >
              </div>

              <div class="ropa-details">
                <div class="detail-row">
                  <div class="detail-item">
                    <span class="label">Project title</span>
                    <span class="value">{{ ropa.project_title }}</span>
                  </div>
                  <div class="detail-item">
                    <span class="label">SET Area</span>
                    <span class="value">{{ ropa.set_area }}</span>
                  </div>
                  <div class="detail-item">
                    <span class="label">Country</span>
                    <span class="value">{{
                      getFormattedCountries(ropa.countries)
                    }}</span>
                  </div>
                  <div class="detail-item">
                    <span class="label">Created Date</span>
                    <span class="value"
                      >{{
                        ropa.created_date | date : "MM/dd/yyyy HH:mm"
                      }}
                      UTC</span
                    >
                  </div>
                  <div class="detail-item">
                    <span class="label">Submitted by:</span>
                    <span class="value">{{ ropa.submitted_by }}</span>
                  </div>
                  <div class="detail-item">
                    <span class="label">Last Modification</span>
                    <span class="value"
                      >{{
                        ropa.updated_at | date : "MM/dd/yyyy HH:mm"
                      }}
                      UTC</span
                    >
                  </div>
                </div>
              </div>

              <div class="ropa-actions">
                <button
                  class="action-btn download-btn"
                  (click)="downloadDraft(ropa)"
                >
                  Download
                </button>
                <div class="flex">
                  <button
                    class="action-btn delete-btn"
                    (click)="deleteDraft(ropa)"
                  >
                    Delete
                  </button>
                  <button
                    class="action-btn delete-btn"
                    (click)="reassignDraft(ropa)"
                  >
                    Reassign
                  </button>
                  <button
                    class="action-btn publish-btn"
                    (click)="publishDraft(ropa)"
                  >
                    Publish
                  </button>
                  <button class="action-btn edit-btn" (click)="editDraft(ropa)">
                    Edit Draft
                  </button>
                  <button
                    class="action-btn view-btn"
                    (click)="viewDraft(ropa, false)"
                  >
                    View Draft
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End My R.O.P.A Tab -->
      </div>
    </div>
  </div>
</div>
<app-az-document-update-modal
  [isOpen]="showBulkImportModal"
  [isUploading]="isBulkUploading"
  [allowedFileTypes]="['xlsx']"
  [documentTypes]="[]"
  [showCommentBox]="false"
  (close)="closeBulkImportModal()"
  (upload)="onBulkUploadConfirmed($event)"
></app-az-document-update-modal>
<app-status-change-modal
  [isOpen]="showExportModal"
  [state]="exportModalState"
  [errorMessage]="exportErrorMessage"
  successMessage="File exported successfully!"
  title="Export"
  (close)="onExportModalClose()"
></app-status-change-modal>
<app-status-change-modal
  [isOpen]="showBulkImportResultModal"
  [state]="bulkImportResultState"
  [errorMessage]="'The file could not be uploaded at this time. Please try again. If the problem continues, contact your system administrator.'"
  successMessage="Your file has been processed. You will receive an email notification once validation is complete."
  title="Bulk Upload"
  (close)="onBulkImportResultModalClose()"
></app-status-change-modal>
<app-status-change-modal
  [isOpen]="showTemplateDownloadModal"
  [state]="templateDownloadModalState"
  [errorMessage]="'The template could not be downloaded at this time. Please try again. If the problem continues, contact your system administrator.'"
  successMessage="Your download has completed successfully."
  title="Download Template"
  (close)="onTemplateDownloadModalClose()"
></app-status-change-modal>
<app-footer></app-footer>

